var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMondayDevSquare = function SvgMondayDevSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none",
    viewBox: "0 0 72 72"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_1371_406875)",
    d: "m37.022 27.938-.086-11.129c-.946-.1-1.89-.054-2.835.023-8.391.788-14.869 7.646-14.693 15.84.143 6.634 4.414 10.993 7.754 13.39 4.755 3.412 10.364 4.827 16.126 5.437 3.393.358 6.969.521 9.49.467l2.87-.056c.347-.007.67-.178.871-.46l3.184-4.474c.278-.391.269-.919-.024-1.3l-3.317-4.315a1.1 1.1 0 0 0-.89-.427l-2.93.056c-1.919.041-4.977-.087-7.971-.404-3.725-.394-7.416-1.091-10.51-3.311-2.012-1.444-3.138-3.036-3.177-4.848-.047-2.176 1.497-4.031 3.612-4.548.826-.202 1.71-.2 2.526.059"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_1371_406875)",
    fillRule: "evenodd",
    d: "M35.464 26.645c.013.604.52 1.071 1.114 1.19 2.135.425 3.757 2.213 3.804 4.388.039 1.813-1.018 3.452-2.965 4.98-3.029 2.376-6.622 3.2-10.359 3.758-2.977.445-6.028.705-7.946.746l-2.796.043a1.1 1.1 0 0 0-1.023.749l-2.953 8.855a1.095 1.095 0 0 0 1.06 1.44l4.118-.072 1.83-.04c2.521-.053 6.086-.37 9.46-.873 3.083-.46 6.803-1.187 9.36-2.336l.007-.002c2.33-.934 4.54-2.238 6.511-3.784 3.234-2.538 7.314-7.076 7.172-13.71-.178-8.242-7.022-14.845-15.509-15.203-.605-.025-1.087.48-1.074 1.084z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#019152",
    d: "M49.174 40.932a78 78 0 0 1-4.603-.346c-3.063-.324-6.102-.853-8.806-2.264-2.648 1.54-5.629 2.18-8.707 2.64a78 78 0 0 1-4.584.543c1.434 1.95 3.159 3.46 4.688 4.557 2.763 1.983 5.815 3.29 9.017 4.159a19 19 0 0 0 1.99-.748l.005-.002c2.33-.934 4.541-2.238 6.512-3.784 1.48-1.162 3.14-2.744 4.488-4.755",
    opacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1371_406875",
    x1: 27.974,
    x2: 38.083,
    y1: 31.251,
    y2: 48.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EAE67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1371_406875",
    x1: 38.601,
    x2: 5.538,
    y1: 33.506,
    y2: 53.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0FFE5"
  })))));
};
export default SvgMondayDevSquare;